import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import {App, AuthProvider} from './App';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter, Router } from 'react-router-dom';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
<React.StrictMode>
    <BrowserRouter> 
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
